export default __webpack_public_path__ + "static/media/laylo-header.3d23dde4.svg";